import { ClaimsItem, RoleCreate, RoleItem } from '../bus/role/types';
import $axios from '../utils/axios-instance';

export default class RoleApi {
  async getRoleList() {
    return await $axios
      .get<{ data: RoleItem[] }>('/v1/Role')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getRoleDetail(data: { id: number | string }) {
    return await $axios
      .get<RoleItem>(`/v1/Role/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getRoleClaims(data: { id: number | string }) {
    return await $axios
      .get<ClaimsItem[]>('/v1/Role/claims')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createRole(data: Omit<RoleCreate, 'id'>) {
    return await $axios
      .post('/v1/Role', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeRole(data: RoleCreate) {
    return await $axios
      .put(`/v1/Role/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteRole(data: { id: number | string }) {
    return await $axios
      .delete(`/v1/Role/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
